require('leaflet')
import { UI } from '../lib/ui.js'
export class Map {
    constructor(element){
        this.map
        window.ui = window.ui ? window.ui : new UI
        this.element = element ? element : (() => ui.element('map'))()
        this.locations
        this.polyline
        this.markers = []
    }
    /**
     * 
     * @param {*} options 
     * @returns 
     */
    get(options){
        if(typeof options === 'object'){
            if(!this.map){
                this.init(options)
                const lng = options.addresses ? options.addresses[0].lng : options.lng,
                      lat = options.addresses ? options.addresses[0].lat : options.lat,
                      popup = options.addresses[0].label ? options.addresses[0].label : options.label
                
                this.marker({ 
                    lat : lat, 
                    lng : lng, 
                    popup : popup
                })
                
           }else{
               this.marker().clear(this.map)
               this.route().clear(this.map)
                options.addresses.forEach( item => {
                    this.marker(item)
                })
                
                if(options.route){
                    this.route(options)
                }
                    
                this.map.fitBounds(options.addresses.map(address=>[address.lat,address.lng]))

           }
           return this.map
  
        }
    }
    /**
     * 
     * @param {*} options 
     */
    marker(options){
        const add = (options) => {
            const icon = options.icon ? options.icon : 'marker-icon',
                  marker = L.marker([options.lat, options.lng],
                        {icon:L.icon({iconUrl:`/images/${icon}.png`,iconAnchor: [13,41]})})
                
            marker.addTo(this.map)
            if(options.popup || options.label) {
                marker.bindPopup(options.popup || options.label)
                if(options.openPopup) marker.openPopup()
            }
        }
        if(typeof options === 'object') 
            add(options)
        if(Array.isArray(options)) 
            options.forEach(option=>add(option))
        
        return {
            clear(map = this.map) {
                map.eachLayer((layer)=> {
                    if(layer instanceof L.Marker)
                        map.removeLayer(layer)
                    
                })
            },
            add : add
        }
    }
    /**
     * 
     * @param {*} options 
     */
    init(options){
        // https://basemaps.cartocdn.com/
        const basemap = options.basemap ? options.basemap : 'voyager_labels_under',
              zoom = options.zoom ? options.zoom : 13,
              attribution = options.attribution ? options.attribution : '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'

        this.map = L.map(this.element.id ? this.element.id : 'map').setView([options.addresses[0]?.lat, options.addresses[0]?.lng], zoom)
        L.tileLayer(`https://{s}.basemaps.cartocdn.com/rastertiles/${basemap}/{z}/{x}/{y}.png`, { attribution: attribution}).addTo(this.map)
    }

    route(options){
        if(typeof options === 'object'){
            this.map.eachLayer((layer)=> {
                if(layer instanceof L.Polyline)
                    this.map.removeLayer(layer)
                
            })
            const polyline_color = options.polyline_color ? options.polyline_color : '#4A8DCB'
            const polybounds = new Array()
            options.route.forEach(route => {
                const polyline = L.polyline(route, {color:polyline_color}).addTo(this.map)
                polybounds.push(polyline.getBounds())
            })
            this.polyline = polybounds
            this.map.fitBounds(polybounds)
        }
        
        return {
            clear(map) {
                map.eachLayer((layer)=> {
                    if(layer instanceof L.Polyline)
                        map.removeLayer(layer)
                    
                })
            }
        }
    }

    setZoom(zoom){
        if(this.map)
            this.map.setZoom(zoom)
    }
}